import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FaTimes, FaExclamationCircle, FaCheckCircle } from 'react-icons/fa';
import { deactivateAccount } from '../../Services/User/Profile';
import { showToast } from '../Toast/Toast';
import CustomButton from '../CustomButton';
import './DeactivateAccountModal.css';

const DeactivateAccountModal = ({ show, onHide }) => {
  const [step, setStep] = useState(1); // 1: Confirmation, 2: Success
  const [deactivating, setDeactivating] = useState(false);

  const handleConfirm = async () => {
    try {
      setDeactivating(true);
      const response = await deactivateAccount();
      
      if (response.status) {
        setStep(2);
      } else {
        showToast(response.message || 'Failed to deactivate account', 'error');
      }
    } catch (error) {
      console.error('Error deactivating account:', error);
      showToast(error.message || 'Failed to deactivate account', 'error');
    } finally {
      setDeactivating(false);
    }
  };

  const handleCancel = () => {
    setStep(1);
    onHide();
  };

  const handleSuccessClose = () => {
    setStep(1);
    onHide();
    // Optionally redirect to login or home page
    window.location.href = '/login';
  };

  const renderConfirmationStep = () => (
    <div className="deactivate-modal-content">
      <div className="deactivate-icon-wrapper">
        <FaExclamationCircle className="deactivate-icon" />
      </div>
      <h4 className="deactivate-modal-title">Deactivate Account</h4>
      <p className="deactivate-modal-question">
        Are you sure you want to deactivate your account?
      </p>
      <div className="deactivate-modal-buttons">
        <CustomButton
          onClick={handleConfirm}
          disabled={deactivating}
          className="deactivate-yes-btn"
        >
          {deactivating ? 'Deactivating...' : 'Yes'}
        </CustomButton>
        <CustomButton
          onClick={handleCancel}
          variant="secondary"
          className="secondaryButton"
        >
          No
        </CustomButton>
      </div>
    </div>
  );

  const renderSuccessStep = () => (
    <div className="deactivate-modal-content">
      <div className="success-icon-wrapper">
        <FaCheckCircle className="success-icon" />
      </div>
      <h4 className="deactivate-modal-title">Successful</h4>
      <p className="success-message">
        Your account has been deactivated successfully!
      </p>
      <div className="deactivate-form-buttons">
        <CustomButton
          onClick={handleSuccessClose}
          className="deactivate-ok-btn"
        >
          Ok
        </CustomButton>
      </div>
    </div>
  );

  return (
    <Modal show={show} onHide={handleCancel} centered className="deactivate-account-modal">
      <Modal.Body className="deactivate-modal-body">
        <button className="modal-close-btn" onClick={handleCancel}>
          <FaTimes />
        </button>
        
        {step === 1 && renderConfirmationStep()}
        {step === 2 && renderSuccessStep()}
      </Modal.Body>
    </Modal>
  );
};

export default DeactivateAccountModal;

